// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}
:host .content {
  overflow: auto;
  overflow-x: hidden;
  flex-grow: 1;
}

:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--kg-bg, #0a0a0f);
  --kg-bg: #0a0a0f;
  --kg-overlay: rgba(20, 20, 30, 0.85);
  --kg-overlay-strong: rgba(20, 20, 30, 0.92);
  --kg-border: rgba(122, 162, 247, 0.2);
  --kg-text: #c0caf5;
  --kg-text-muted: #555;
  --kg-text-dim: #444;
  --kg-accent: #7aa2f7;
  --kg-hover: rgba(255, 255, 255, 0.08);
}

:host-context(.light) {
  --kg-bg: #f0f2f8;
  --kg-overlay: rgba(255, 255, 255, 0.9);
  --kg-overlay-strong: rgba(255, 255, 255, 0.95);
  --kg-border: rgba(80, 100, 160, 0.25);
  --kg-text: #1a1a2e;
  --kg-text-muted: #888;
  --kg-text-dim: #999;
  --kg-accent: #4a6cc9;
  --kg-hover: rgba(0, 0, 0, 0.05);
}

.widget-body {
  flex: 1;
  position: relative;
  overflow: hidden;
}
.widget-body canvas {
  display: block;
  width: 100%;
  height: 100%;
}

.kg-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: var(--kg-accent);
  font-size: 13px;
  z-index: 5;
}

.kg-error {
  color: #f7768e;
}

.kg-legend {
  position: absolute;
  bottom: 10px;
  left: 10px;
  z-index: 5;
  background: var(--kg-overlay);
  border-radius: 6px;
  padding: 8px 12px;
  backdrop-filter: blur(8px);
  font-size: 11px;
}

.kg-legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 2px 0;
  cursor: pointer;
  padding: 2px 4px;
  border-radius: 4px;
  transition: opacity 0.15s ease, background 0.15s ease;
}
.kg-legend-item:hover {
  background: var(--kg-hover);
}
.kg-legend-item.dimmed {
  opacity: 0.35;
}
.kg-legend-item.active {
  background: var(--kg-hover);
}

.kg-legend-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.kg-stats {
  position: absolute;
  top: 8px;
  left: 10px;
  z-index: 5;
  font-size: 11px;
  color: var(--kg-text-muted);
}
.kg-stats span {
  color: var(--kg-accent);
}

.kg-search {
  position: absolute;
  top: 26px;
  left: 10px;
  z-index: 8;
  width: 220px;
}

.kg-search-input-wrap {
  display: flex;
  align-items: center;
  background: var(--kg-overlay);
  border: 1px solid var(--kg-border);
  border-radius: 6px;
  padding: 0 8px;
  backdrop-filter: blur(8px);
}

.kg-search-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
  color: var(--kg-text-muted);
  margin-right: 4px;
}

.kg-search-input {
  flex: 1;
  background: none;
  border: none;
  outline: none;
  color: var(--kg-text);
  font-size: 12px;
  padding: 6px 0;
  font-family: inherit;
}
.kg-search-input::placeholder {
  color: var(--kg-text-dim);
}

.kg-search-clear {
  font-size: 14px;
  color: var(--kg-text-muted);
  cursor: pointer;
}
.kg-search-clear:hover {
  color: var(--kg-text);
}

.kg-search-results {
  margin-top: 4px;
  background: var(--kg-overlay-strong);
  border: 1px solid var(--kg-border);
  border-radius: 6px;
  backdrop-filter: blur(10px);
  overflow: hidden;
}

.kg-search-result {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  cursor: pointer;
  transition: background 0.1s ease;
}
.kg-search-result:hover, .kg-search-result.active {
  background: var(--kg-hover);
}

.kg-search-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}

.kg-search-label {
  flex: 1;
  font-size: 12px;
  color: var(--kg-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kg-search-type {
  font-size: 9px;
  color: var(--kg-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.kg-search-count {
  font-size: 10px;
  color: var(--kg-accent);
  min-width: 14px;
  text-align: right;
}

.kg-info-panel {
  position: absolute;
  top: 8px;
  right: 10px;
  width: 260px;
  background: var(--kg-overlay-strong);
  border: 1px solid var(--kg-border);
  border-radius: 8px;
  padding: 14px;
  backdrop-filter: blur(12px);
  z-index: 10;
  max-height: 50vh;
  overflow-y: auto;
  font-size: 12px;
}
.kg-info-panel h3 {
  color: var(--kg-accent);
  margin: 0 0 4px 0;
  font-size: 14px;
}

.kg-type-badge {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}

.kg-close {
  position: absolute;
  top: 8px;
  right: 10px;
  cursor: pointer;
  color: var(--kg-text-muted);
  font-size: 14px;
}
.kg-close:hover {
  color: var(--kg-text);
}

.kg-count {
  color: var(--kg-text-muted);
  margin-bottom: 8px;
}

.kg-messages .kg-msg-link {
  display: block;
  padding: 3px 0;
  border-bottom: 1px solid var(--kg-border);
  color: var(--kg-accent);
  font-size: 10px;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.15s ease;
}
.kg-messages .kg-msg-link:hover {
  color: var(--kg-text);
  text-decoration: underline;
}

.kg-hover-tooltip {
  position: absolute;
  z-index: 15;
  pointer-events: none;
  background: var(--kg-overlay-strong);
  border: 1px solid var(--kg-border);
  border-radius: 6px;
  padding: 5px 10px;
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  font-size: 12px;
}

.kg-hover-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

.kg-hover-label {
  color: var(--kg-text);
  font-weight: 500;
}

.kg-hover-count {
  color: var(--kg-accent);
  font-size: 10px;
  opacity: 0.7;
}
.kg-hover-count::before {
  content: "(";
}
.kg-hover-count::after {
  content: ")";
}

.kg-controls {
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 5;
  font-size: 10px;
  color: var(--kg-text-dim);
}
.kg-controls strong {
  color: var(--kg-accent);
}

.fly-hud {
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  background: rgba(10, 10, 20, 0.85);
  border: 1px solid rgba(122, 162, 247, 0.3);
  border-radius: 8px;
  padding: 8px 16px;
  backdrop-filter: blur(10px);
  text-align: center;
  min-width: 200px;
}

.fly-hud-label {
  font-size: 9px;
  letter-spacing: 2px;
  color: #7aa2f7;
  margin-bottom: 6px;
  text-transform: uppercase;
  animation: fly-pulse 2s ease-in-out infinite;
}

@keyframes fly-pulse {
  0%, 100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}
.fly-speed-bar {
  height: 3px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
  margin-bottom: 6px;
  overflow: hidden;
}

.fly-speed-fill {
  height: 100%;
  background: linear-gradient(90deg, #7aa2f7, #f7768e);
  border-radius: 2px;
  transition: width 0.1s ease;
}

.fly-keys {
  display: flex;
  gap: 4px;
  justify-content: center;
  margin-bottom: 4px;
}
.fly-keys span {
  display: inline-block;
  font-size: 9px;
  padding: 2px 6px;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.06);
  color: #555;
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: all 0.1s ease;
  font-family: monospace;
}
.fly-keys span.active {
  background: rgba(122, 162, 247, 0.25);
  color: #7aa2f7;
  border-color: rgba(122, 162, 247, 0.5);
  box-shadow: 0 0 6px rgba(122, 162, 247, 0.3);
}
.fly-keys span.spacebar {
  padding: 2px 12px;
}
.fly-keys span.spacebar.active {
  background: rgba(247, 118, 142, 0.25);
  color: #f7768e;
  border-color: rgba(247, 118, 142, 0.5);
  box-shadow: 0 0 8px rgba(247, 118, 142, 0.4);
}

.fly-hint {
  font-size: 9px;
  color: #444;
}
.fly-hint strong {
  color: #f7768e;
}

.combat-hud {
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  background: rgba(30, 10, 15, 0.85);
  border: 1px solid rgba(247, 118, 142, 0.4);
  border-radius: 8px;
  padding: 8px 20px;
  backdrop-filter: blur(10px);
  text-align: center;
}

.combat-hud-label {
  font-size: 10px;
  letter-spacing: 3px;
  color: #f7768e;
  text-transform: uppercase;
  animation: combat-pulse 1.5s ease-in-out infinite;
  margin-bottom: 4px;
}

@keyframes combat-pulse {
  0%, 100% {
    opacity: 0.7;
    text-shadow: 0 0 4px rgba(247, 118, 142, 0.3);
  }
  50% {
    opacity: 1;
    text-shadow: 0 0 12px rgba(247, 118, 142, 0.8);
  }
}
.combat-scores {
  display: flex;
  gap: 16px;
  justify-content: center;
  font-size: 13px;
  font-family: monospace;
  font-weight: bold;
}

.combat-kills {
  color: #9ece6a;
  text-shadow: 0 0 6px rgba(158, 206, 106, 0.4);
}

.combat-nodes {
  color: #7aa2f7;
  text-shadow: 0 0 6px rgba(122, 162, 247, 0.4);
}

.combat-lost {
  color: #f7768e;
  text-shadow: 0 0 6px rgba(247, 118, 142, 0.4);
}

.combat-game-over {
  color: #ff4444;
  font-size: 12px;
  letter-spacing: 4px;
  animation: game-over-flash 0.8s ease-in-out infinite;
}

@keyframes game-over-flash {
  0%, 100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
    text-shadow: 0 0 20px rgba(255, 68, 68, 0.8);
  }
}
.combat-hint {
  font-size: 9px;
  color: #555;
  margin-top: 4px;
}

.crosshair {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 15;
  pointer-events: none;
}

.crosshair-h, .crosshair-v {
  position: absolute;
  background: rgba(122, 162, 247, 0.6);
}

.crosshair-h {
  width: 20px;
  height: 1px;
  top: 0;
  left: -10px;
}

.crosshair-v {
  width: 1px;
  height: 20px;
  top: -10px;
  left: 0;
}

.crosshair-dot {
  position: absolute;
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #7aa2f7;
  top: -1px;
  left: -1px;
  box-shadow: 0 0 6px rgba(122, 162, 247, 0.8);
}

.threat-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 12;
  pointer-events: none;
}

.spread-fire-hud {
  position: absolute;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  text-align: center;
}

.spread-fire-label {
  font-size: 10px;
  letter-spacing: 2px;
  color: #9ece6a;
  text-shadow: 0 0 8px rgba(158, 206, 106, 0.6);
  animation: spread-pulse 0.8s ease-in-out infinite;
}

@keyframes spread-pulse {
  0%, 100% {
    opacity: 0.7;
  }
  50% {
    opacity: 1;
  }
}
.spread-fire-bar {
  width: 120px;
  height: 3px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
  margin-top: 4px;
  overflow: hidden;
}

.spread-fire-fill {
  height: 100%;
  background: linear-gradient(90deg, #9ece6a, #73daca);
  border-radius: 2px;
  transition: width 0.2s ease;
}

.kg-preview-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 20;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.kg-preview-panel {
  position: relative;
  width: 70%;
  max-width: 600px;
  max-height: 70vh;
  background: var(--kg-overlay-strong);
  border: 1px solid var(--kg-border);
  border-radius: 10px;
  padding: 18px 20px;
  backdrop-filter: blur(14px);
  overflow-y: auto;
}

.kg-preview-ref {
  font-size: 11px;
  color: var(--kg-accent);
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--kg-border);
}

.kg-preview-loading {
  color: var(--kg-text-muted);
  font-size: 12px;
}

.kg-preview-panel ::ng-deep app-tool-message {
  font-size: 13px;
  line-height: 1.6;
  color: var(--kg-text);
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/base-widget/base-widget.component.scss","webpack://./src/app/components/strategy-grid/knowledge-graph-widget/knowledge-graph-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;ACCF;ADCE;EACE,cAAA;EACA,kBAAA;EACA,YAAA;ACCJ;;AAPA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,iCAAA;EACA,gBAAA;EACA,oCAAA;EACA,2CAAA;EACA,qCAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,qCAAA;AAUF;;AAPA;EACE,gBAAA;EACA,sCAAA;EACA,8CAAA;EACA,qCAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,+BAAA;AAUF;;AAPA;EACE,OAAA;EACA,kBAAA;EACA,gBAAA;AAUF;AARE;EACE,cAAA;EACA,WAAA;EACA,YAAA;AAUJ;;AANA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,6BAAA;EACA,kBAAA;EACA,iBAAA;EACA,0BAAA;EACA,eAAA;AASF;;AANA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qDAAA;AASF;AAPE;EACE,2BAAA;AASJ;AANE;EACE,aAAA;AAQJ;AALE;EACE,2BAAA;AAOJ;;AAHA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AAMF;;AAHA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;EACA,2BAAA;AAMF;AAJE;EAAO,uBAAA;AAOT;;AAHA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;AAMF;;AAHA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,kCAAA;EACA,kBAAA;EACA,cAAA;EACA,0BAAA;AAMF;;AAHA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,2BAAA;EACA,iBAAA;AAMF;;AAHA;EACE,OAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;AAMF;AAJE;EAAiB,yBAAA;AAOnB;;AAJA;EACE,eAAA;EACA,2BAAA;EACA,eAAA;AAOF;AALE;EAAU,qBAAA;AAQZ;;AALA;EACE,eAAA;EACA,oCAAA;EACA,kCAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;AAQF;;AALA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gCAAA;AAQF;AANE;EACE,2BAAA;AAQJ;;AAJA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AAOF;;AAJA;EACE,OAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAOF;;AAJA;EACE,cAAA;EACA,2BAAA;EACA,yBAAA;EACA,qBAAA;AAOF;;AAJA;EACE,eAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;AAOF;;AAJA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,kCAAA;EACA,kBAAA;EACA,aAAA;EACA,2BAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAOF;AALE;EACE,uBAAA;EACA,iBAAA;EACA,eAAA;AAOJ;;AAHA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;AAMF;;AAHA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;EACA,2BAAA;EACA,eAAA;AAMF;AAJE;EAAU,qBAAA;AAOZ;;AAJA;EACE,2BAAA;EACA,kBAAA;AAOF;;AAHE;EACE,cAAA;EACA,cAAA;EACA,yCAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;EACA,4BAAA;AAMJ;AAJI;EACE,qBAAA;EACA,0BAAA;AAMN;;AAAA;EACE,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,oCAAA;EACA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;AAGF;;AAAA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AAGF;;AAAA;EACE,qBAAA;EACA,gBAAA;AAGF;;AAAA;EACE,uBAAA;EACA,eAAA;EACA,YAAA;AAGF;AADE;EAAY,YAAA;AAId;AAHE;EAAW,YAAA;AAMb;;AAHA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,yBAAA;AAMF;AAJE;EAAS,uBAAA;AAOX;;AAHA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,kCAAA;EACA,0CAAA;EACA,kBAAA;EACA,iBAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;AAMF;;AAHA;EACE,cAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,4CAAA;AAMF;;AAHA;EACE;IAAW,YAAA;EAOX;EANA;IAAM,UAAA;EASN;AACF;AAPA;EACE,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AASF;;AANA;EACE,YAAA;EACA,oDAAA;EACA,kBAAA;EACA,2BAAA;AASF;;AANA;EACE,aAAA;EACA,QAAA;EACA,uBAAA;EACA,kBAAA;AASF;AAPE;EACE,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,qCAAA;EACA,WAAA;EACA,2CAAA;EACA,yBAAA;EACA,sBAAA;AASJ;AAPI;EACE,qCAAA;EACA,cAAA;EACA,sCAAA;EACA,4CAAA;AASN;AANI;EACE,iBAAA;AAQN;AANM;EACE,qCAAA;EACA,cAAA;EACA,sCAAA;EACA,4CAAA;AAQR;;AAFA;EACE,cAAA;EACA,WAAA;AAKF;AAHE;EAAS,cAAA;AAMX;;AAFA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,kCAAA;EACA,0CAAA;EACA,kBAAA;EACA,iBAAA;EACA,2BAAA;EACA,kBAAA;AAKF;;AAFA;EACE,eAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,iDAAA;EACA,kBAAA;AAKF;;AAFA;EACE;IAAW,YAAA;IAAc,6CAAA;EAOzB;EANA;IAAM,UAAA;IAAY,8CAAA;EAUlB;AACF;AARA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;AAUF;;AAPA;EACE,cAAA;EACA,6CAAA;AAUF;;AAPA;EACE,cAAA;EACA,6CAAA;AAUF;;AAPA;EACE,cAAA;EACA,6CAAA;AAUF;;AAPA;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oDAAA;AAUF;;AAPA;EACE;IAAW,YAAA;EAWX;EAVA;IAAM,UAAA;IAAY,4CAAA;EAclB;AACF;AAZA;EACE,cAAA;EACA,WAAA;EACA,eAAA;AAcF;;AAVA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,oBAAA;AAaF;;AAVA;EACE,kBAAA;EACA,oCAAA;AAaF;;AAVA;EACE,WAAA;EACA,WAAA;EACA,MAAA;EACA,WAAA;AAaF;;AAVA;EACE,UAAA;EACA,YAAA;EACA,UAAA;EACA,OAAA;AAaF;;AAVA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,4CAAA;AAaF;;AATA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;AAYF;;AARA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,kBAAA;AAWF;;AARA;EACE,eAAA;EACA,mBAAA;EACA,cAAA;EACA,6CAAA;EACA,iDAAA;AAWF;;AARA;EACE;IAAW,YAAA;EAYX;EAXA;IAAM,UAAA;EAcN;AACF;AAZA;EACE,YAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAcF;;AAXA;EACE,YAAA;EACA,oDAAA;EACA,kBAAA;EACA,2BAAA;AAcF;;AAVA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAaF;;AAVA;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;EACA,kCAAA;EACA,mBAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;AAaF;;AAVA;EACE,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yCAAA;AAaF;;AAVA;EACE,2BAAA;EACA,eAAA;AAaF;;AAVA;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;AAaF","sourcesContent":[":host {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n\n  .content {\n    overflow: auto;\n    overflow-x: hidden;\n    flex-grow: 1;\n  }\n}\n","@import '../base-widget/base-widget.component.scss';\n\n:host {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: var(--kg-bg, #0a0a0f);\n  --kg-bg: #0a0a0f;\n  --kg-overlay: rgba(20, 20, 30, 0.85);\n  --kg-overlay-strong: rgba(20, 20, 30, 0.92);\n  --kg-border: rgba(122, 162, 247, 0.2);\n  --kg-text: #c0caf5;\n  --kg-text-muted: #555;\n  --kg-text-dim: #444;\n  --kg-accent: #7aa2f7;\n  --kg-hover: rgba(255, 255, 255, 0.08);\n}\n\n:host-context(.light) {\n  --kg-bg: #f0f2f8;\n  --kg-overlay: rgba(255, 255, 255, 0.9);\n  --kg-overlay-strong: rgba(255, 255, 255, 0.95);\n  --kg-border: rgba(80, 100, 160, 0.25);\n  --kg-text: #1a1a2e;\n  --kg-text-muted: #888;\n  --kg-text-dim: #999;\n  --kg-accent: #4a6cc9;\n  --kg-hover: rgba(0, 0, 0, 0.05);\n}\n\n.widget-body {\n  flex: 1;\n  position: relative;\n  overflow: hidden;\n\n  canvas {\n    display: block;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.kg-loading {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: var(--kg-accent);\n  font-size: 13px;\n  z-index: 5;\n}\n\n.kg-error {\n  color: #f7768e;\n}\n\n.kg-legend {\n  position: absolute;\n  bottom: 10px;\n  left: 10px;\n  z-index: 5;\n  background: var(--kg-overlay);\n  border-radius: 6px;\n  padding: 8px 12px;\n  backdrop-filter: blur(8px);\n  font-size: 11px;\n}\n\n.kg-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin: 2px 0;\n  cursor: pointer;\n  padding: 2px 4px;\n  border-radius: 4px;\n  transition: opacity 0.15s ease, background 0.15s ease;\n\n  &:hover {\n    background: var(--kg-hover);\n  }\n\n  &.dimmed {\n    opacity: 0.35;\n  }\n\n  &.active {\n    background: var(--kg-hover);\n  }\n}\n\n.kg-legend-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.kg-stats {\n  position: absolute;\n  top: 8px;\n  left: 10px;\n  z-index: 5;\n  font-size: 11px;\n  color: var(--kg-text-muted);\n\n  span { color: var(--kg-accent); }\n}\n\n// Search\n.kg-search {\n  position: absolute;\n  top: 26px;\n  left: 10px;\n  z-index: 8;\n  width: 220px;\n}\n\n.kg-search-input-wrap {\n  display: flex;\n  align-items: center;\n  background: var(--kg-overlay);\n  border: 1px solid var(--kg-border);\n  border-radius: 6px;\n  padding: 0 8px;\n  backdrop-filter: blur(8px);\n}\n\n.kg-search-icon {\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n  line-height: 16px;\n  color: var(--kg-text-muted);\n  margin-right: 4px;\n}\n\n.kg-search-input {\n  flex: 1;\n  background: none;\n  border: none;\n  outline: none;\n  color: var(--kg-text);\n  font-size: 12px;\n  padding: 6px 0;\n  font-family: inherit;\n\n  &::placeholder { color: var(--kg-text-dim); }\n}\n\n.kg-search-clear {\n  font-size: 14px;\n  color: var(--kg-text-muted);\n  cursor: pointer;\n\n  &:hover { color: var(--kg-text); }\n}\n\n.kg-search-results {\n  margin-top: 4px;\n  background: var(--kg-overlay-strong);\n  border: 1px solid var(--kg-border);\n  border-radius: 6px;\n  backdrop-filter: blur(10px);\n  overflow: hidden;\n}\n\n.kg-search-result {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  cursor: pointer;\n  transition: background 0.1s ease;\n\n  &:hover, &.active {\n    background: var(--kg-hover);\n  }\n}\n\n.kg-search-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.kg-search-label {\n  flex: 1;\n  font-size: 12px;\n  color: var(--kg-text);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.kg-search-type {\n  font-size: 9px;\n  color: var(--kg-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.kg-search-count {\n  font-size: 10px;\n  color: var(--kg-accent);\n  min-width: 14px;\n  text-align: right;\n}\n\n.kg-info-panel {\n  position: absolute;\n  top: 8px;\n  right: 10px;\n  width: 260px;\n  background: var(--kg-overlay-strong);\n  border: 1px solid var(--kg-border);\n  border-radius: 8px;\n  padding: 14px;\n  backdrop-filter: blur(12px);\n  z-index: 10;\n  max-height: 50vh;\n  overflow-y: auto;\n  font-size: 12px;\n\n  h3 {\n    color: var(--kg-accent);\n    margin: 0 0 4px 0;\n    font-size: 14px;\n  }\n}\n\n.kg-type-badge {\n  display: inline-block;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 6px;\n}\n\n.kg-close {\n  position: absolute;\n  top: 8px;\n  right: 10px;\n  cursor: pointer;\n  color: var(--kg-text-muted);\n  font-size: 14px;\n\n  &:hover { color: var(--kg-text); }\n}\n\n.kg-count {\n  color: var(--kg-text-muted);\n  margin-bottom: 8px;\n}\n\n.kg-messages {\n  .kg-msg-link {\n    display: block;\n    padding: 3px 0;\n    border-bottom: 1px solid var(--kg-border);\n    color: var(--kg-accent);\n    font-size: 10px;\n    cursor: pointer;\n    text-decoration: none;\n    transition: color 0.15s ease;\n\n    &:hover {\n      color: var(--kg-text);\n      text-decoration: underline;\n    }\n  }\n}\n\n// Hover tooltip\n.kg-hover-tooltip {\n  position: absolute;\n  z-index: 15;\n  pointer-events: none;\n  background: var(--kg-overlay-strong);\n  border: 1px solid var(--kg-border);\n  border-radius: 6px;\n  padding: 5px 10px;\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n  font-size: 12px;\n}\n\n.kg-hover-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.kg-hover-label {\n  color: var(--kg-text);\n  font-weight: 500;\n}\n\n.kg-hover-count {\n  color: var(--kg-accent);\n  font-size: 10px;\n  opacity: 0.7;\n\n  &::before { content: '('; }\n  &::after { content: ')'; }\n}\n\n.kg-controls {\n  position: absolute;\n  bottom: 10px;\n  right: 10px;\n  z-index: 5;\n  font-size: 10px;\n  color: var(--kg-text-dim);\n\n  strong { color: var(--kg-accent); }\n}\n\n// Fly mode HUD\n.fly-hud {\n  position: absolute;\n  bottom: 12px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n  background: rgba(10, 10, 20, 0.85);\n  border: 1px solid rgba(122, 162, 247, 0.3);\n  border-radius: 8px;\n  padding: 8px 16px;\n  backdrop-filter: blur(10px);\n  text-align: center;\n  min-width: 200px;\n}\n\n.fly-hud-label {\n  font-size: 9px;\n  letter-spacing: 2px;\n  color: #7aa2f7;\n  margin-bottom: 6px;\n  text-transform: uppercase;\n  animation: fly-pulse 2s ease-in-out infinite;\n}\n\n@keyframes fly-pulse {\n  0%, 100% { opacity: 0.6; }\n  50% { opacity: 1; }\n}\n\n.fly-speed-bar {\n  height: 3px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 2px;\n  margin-bottom: 6px;\n  overflow: hidden;\n}\n\n.fly-speed-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #7aa2f7, #f7768e);\n  border-radius: 2px;\n  transition: width 0.1s ease;\n}\n\n.fly-keys {\n  display: flex;\n  gap: 4px;\n  justify-content: center;\n  margin-bottom: 4px;\n\n  span {\n    display: inline-block;\n    font-size: 9px;\n    padding: 2px 6px;\n    border-radius: 3px;\n    background: rgba(255, 255, 255, 0.06);\n    color: #555;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    transition: all 0.1s ease;\n    font-family: monospace;\n\n    &.active {\n      background: rgba(122, 162, 247, 0.25);\n      color: #7aa2f7;\n      border-color: rgba(122, 162, 247, 0.5);\n      box-shadow: 0 0 6px rgba(122, 162, 247, 0.3);\n    }\n\n    &.spacebar {\n      padding: 2px 12px;\n\n      &.active {\n        background: rgba(247, 118, 142, 0.25);\n        color: #f7768e;\n        border-color: rgba(247, 118, 142, 0.5);\n        box-shadow: 0 0 8px rgba(247, 118, 142, 0.4);\n      }\n    }\n  }\n}\n\n.fly-hint {\n  font-size: 9px;\n  color: #444;\n\n  strong { color: #f7768e; }\n}\n\n// Combat HUD\n.combat-hud {\n  position: absolute;\n  top: 12px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n  background: rgba(30, 10, 15, 0.85);\n  border: 1px solid rgba(247, 118, 142, 0.4);\n  border-radius: 8px;\n  padding: 8px 20px;\n  backdrop-filter: blur(10px);\n  text-align: center;\n}\n\n.combat-hud-label {\n  font-size: 10px;\n  letter-spacing: 3px;\n  color: #f7768e;\n  text-transform: uppercase;\n  animation: combat-pulse 1.5s ease-in-out infinite;\n  margin-bottom: 4px;\n}\n\n@keyframes combat-pulse {\n  0%, 100% { opacity: 0.7; text-shadow: 0 0 4px rgba(247, 118, 142, 0.3); }\n  50% { opacity: 1; text-shadow: 0 0 12px rgba(247, 118, 142, 0.8); }\n}\n\n.combat-scores {\n  display: flex;\n  gap: 16px;\n  justify-content: center;\n  font-size: 13px;\n  font-family: monospace;\n  font-weight: bold;\n}\n\n.combat-kills {\n  color: #9ece6a;\n  text-shadow: 0 0 6px rgba(158, 206, 106, 0.4);\n}\n\n.combat-nodes {\n  color: #7aa2f7;\n  text-shadow: 0 0 6px rgba(122, 162, 247, 0.4);\n}\n\n.combat-lost {\n  color: #f7768e;\n  text-shadow: 0 0 6px rgba(247, 118, 142, 0.4);\n}\n\n.combat-game-over {\n  color: #ff4444;\n  font-size: 12px;\n  letter-spacing: 4px;\n  animation: game-over-flash 0.8s ease-in-out infinite;\n}\n\n@keyframes game-over-flash {\n  0%, 100% { opacity: 0.5; }\n  50% { opacity: 1; text-shadow: 0 0 20px rgba(255, 68, 68, 0.8); }\n}\n\n.combat-hint {\n  font-size: 9px;\n  color: #555;\n  margin-top: 4px;\n}\n\n// Crosshair\n.crosshair {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 15;\n  pointer-events: none;\n}\n\n.crosshair-h, .crosshair-v {\n  position: absolute;\n  background: rgba(122, 162, 247, 0.6);\n}\n\n.crosshair-h {\n  width: 20px;\n  height: 1px;\n  top: 0;\n  left: -10px;\n}\n\n.crosshair-v {\n  width: 1px;\n  height: 20px;\n  top: -10px;\n  left: 0;\n}\n\n.crosshair-dot {\n  position: absolute;\n  width: 3px;\n  height: 3px;\n  border-radius: 50%;\n  background: #7aa2f7;\n  top: -1px;\n  left: -1px;\n  box-shadow: 0 0 6px rgba(122, 162, 247, 0.8);\n}\n\n// Threat indicator overlay\n.threat-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 12;\n  pointer-events: none;\n}\n\n// Spread fire HUD\n.spread-fire-hud {\n  position: absolute;\n  bottom: 80px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n  text-align: center;\n}\n\n.spread-fire-label {\n  font-size: 10px;\n  letter-spacing: 2px;\n  color: #9ece6a;\n  text-shadow: 0 0 8px rgba(158, 206, 106, 0.6);\n  animation: spread-pulse 0.8s ease-in-out infinite;\n}\n\n@keyframes spread-pulse {\n  0%, 100% { opacity: 0.7; }\n  50% { opacity: 1; }\n}\n\n.spread-fire-bar {\n  width: 120px;\n  height: 3px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 2px;\n  margin-top: 4px;\n  overflow: hidden;\n}\n\n.spread-fire-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #9ece6a, #73daca);\n  border-radius: 2px;\n  transition: width 0.2s ease;\n}\n\n// Message preview popup\n.kg-preview-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 20;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.kg-preview-panel {\n  position: relative;\n  width: 70%;\n  max-width: 600px;\n  max-height: 70vh;\n  background: var(--kg-overlay-strong);\n  border: 1px solid var(--kg-border);\n  border-radius: 10px;\n  padding: 18px 20px;\n  backdrop-filter: blur(14px);\n  overflow-y: auto;\n}\n\n.kg-preview-ref {\n  font-size: 11px;\n  color: var(--kg-accent);\n  margin-bottom: 10px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid var(--kg-border);\n}\n\n.kg-preview-loading {\n  color: var(--kg-text-muted);\n  font-size: 12px;\n}\n\n.kg-preview-panel ::ng-deep app-tool-message {\n  font-size: 13px;\n  line-height: 1.6;\n  color: var(--kg-text);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
